<template>
	<div>
		<h1 class="page-header mb-0"><i class="fas fa-user"></i> Profilom</h1>
		<hr>
		<div class="row">
			<div class="col-12 col-md-6">
				<panel title="Alapadatok" :headerClass="{'bg-blue text-white': user && user.role_id == 10}" noButton="true">
					<template slot="header">
						<h4 class="panel-title">Alapadatok</h4>
						<help title="Alapadatok" text="alapadatait szerkesztheti, később ezeket használja a foglaláshoz" helpId="base_data_panel"></help>
					</template>
					<Loading v-if="!form_user.details"></Loading>
					<div v-else>
						<div class="note note-danger text-white" v-if="user && (!user.profile_complete || !user.last_updated) && user.role_id == 10">
							<div class="note-icon"><i class="fa fa-exclamation-triangle"></i></div>
							<div class="note-content" v-if="!user.last_updated && user.profile_complete">
								<h4><b>Ellenőrizze adatait!</b></h4>
								<p>Mentés gombra kattintás után léphet tovább!</p>
							</div>
							<div class="note-content" v-else>
								<h4><b>Korábbi regisztrációja során hiányosan töltötte ki adatait!</b></h4>
								<p>Módosítsa adatait és kattintson a mentés gombra!</p>
							</div>
						</div>
						<form @submit.prevent="updateUser">
							<div class="form-group">
								<label class="form-label">Név:</label>
								<input type="text" class="form-control" v-model="form_user.name" required>
								<div class="invalid-feedback d-block" v-if="errors.name">
										{{ errors.name[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Tagazonosító:</label>
								<input type="text" class="form-control" v-model="form_user.details.membership_id">
								<div class="invalid-feedback d-block" v-if="errors.membership_id">
										{{ errors.membership_id[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Adóazonosító:</label>
								<input type="text" class="form-control" v-model="form_user.details.tin">
								<div class="invalid-feedback d-block" v-if="errors.tin">
										{{ errors.tin[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Születési dátum:</label>
								<input type="date" max="2050-12-31" class="form-control" v-model="form_user.details.birth_date" required>
								<div class="invalid-feedback d-block" v-if="errors.birth_date">
										{{ errors.birth_date[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Email:</label>
								<input type="email" class="form-control" v-model="form_user.email" required>
								<div class="invalid-feedback d-block" v-if="errors.email">
										{{ errors.email[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Irányítószám:</label>
								<input type="number" class="form-control" v-model="form_user.details.postal_code" required>
								<div class="invalid-feedback d-block" v-if="errors.postal_code">
										{{ errors.postal_code[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Város:</label>
								<input type="text" class="form-control" v-model="form_user.details.city" required>
								<div class="invalid-feedback d-block" v-if="errors.city">
										{{ errors.city[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Cím:</label>
								<input type="text" class="form-control" v-model="form_user.details.street_address" required>
								<div class="invalid-feedback d-block" v-if="errors.street_address">
										{{ errors.street_address[0] }}
								</div>
							</div>
							<div class="form-group mt-2">
								<label class="form-label">Telefonszám:</label>
								<input type="text" class="form-control" v-model="form_user.details.phone">
								<div class="invalid-feedback d-block" v-if="errors.phone">
										{{ errors.phone[0] }}
								</div>
							</div>
							<div slot="footer" class="text-end mt-2">
								<button class="btn btn-success btn-icon btn-lg"><i class="fa fa-save"></i></button>
							</div>
						</form>
					</div>
				</panel>
			</div>
			<div class="col-12 col-md-6">
				<panel title="Jelszó" :headerClass="{'bg-blue text-white': user && user.role_id == 10}" noButton="true">
					<template slot="header">
						<h4 class="panel-title">Jelszó</h4>
						<help title="Jelszó" text="bejelentkezési jelszavát változtathatja meg " helpId="passwd_data_panel"></help>
					</template>
					<form @submit.prevent="updatePassword">
						<div class="form-group">
							<label class="form-label">Új jelszó:</label>
							<input type="password" autocomplete="off" class="form-control" v-model="password1" required>
							<div class="invalid-feedback d-block" v-if="errors.password">
									{{ errors.password[0] }}
							</div>
						</div>
						<div class="form-group mt-2">
							<label class="form-label">Új jelszó Mégegyszer:</label>
							<input type="password" autocomplete="off" class="form-control" v-model="password2" required>
							<div class="invalid-feedback d-block" v-if="errors.password">
									{{ errors.password[0] }}
							</div>
						</div>
						<div slot="footer" class="text-end mt-2">
							<button class="btn btn-success btn-icon btn-lg"><i class="fa fa-save"></i></button>
						</div>
					</form>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
	import User from "../../apis/User";
	import Confirmation from "../../apis/Confirmation";
	export default {
		data() {
			return {
				password1: null,
				password2: null,
				pin1: null,
				pin2: null,
				form_user: {},
				errors:[],
			}
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
		},
		watch:{
			user:function(){
				this.form_user = JSON.parse(JSON.stringify(this.user));
				if(!this.form_user.details){
					this.form_user.details = {};
				}
			}
		},
		mounted(){
			if(this.user){
				this.form_user = JSON.parse(JSON.stringify(this.user));
				if(!this.form_user.details){
					this.form_user.details = {};
				}
			}
		},
		methods:{
			updateUser(){
				User.updateSelf(this.form_user)
				.then(response => {
					this.errors = [];
					this.$store.commit('updateUser',response.data);
					if(this.user.role_id == 10){
						this.$router.push({ name: "Booking" });
					}
				})
				.catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				});
			},
			updatePassword(){
				if(this.password1 != this.password2){
					Confirmation.swalErrorMessage('A jelszavak nem egyeznek!');
				}else {
					User.setPassword({password: this.password1})
					.then(/*response*/() => {
						this.errors = [];
						//this.$store.commit('updateUser',response.data);
					})
					.catch(error => {
						if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
					});
				}
			},
		},
		beforeRouteLeave (to, from , next) {
			if(this.user && !this.user.profile_complete && this.user.role_id == 10){
				Confirmation.swalBigErrorMessage('Nem foglalhat amíg nem töltött ki minden adatot!')
			}else{
				next();
			}
		}
	}
</script>